import {FormInstance} from "antd/lib/form";
import {Form} from "antd";
import {useState} from "react";
import {useRequest} from "ahooks";
import {ModalProps} from "antd/lib/modal";
import {Service} from "ahooks/lib/useRequest/src/types";

export interface FormModalProps extends ModalProps {
    form: FormInstance
    onOk?: (event: any, extra?: { [key: string]: any }) => void
}

interface Params {
    normalize?: (values: any) => any
    onOk: (values: any) => void
    beforeRequest?: (values: any) => any
    onRequest?: Service<any, any[]>
}

interface Result<T> {
    visible: boolean,
    setVisible: (visible: boolean, record?: T) => void
    modalProps: {
        form: FormInstance
        open: boolean
        onCancel: () => void
        onOk: (event: any, extra?: { [key: string]: any }) => void
        confirmLoading: boolean
    }
}

function useFormModal<T = any>(params: Params): Result<T> {
    const [form] = Form.useForm()

    const [visible, setVisible] = useState(false)
    const [records, setRecords] = useState<T>()

    const {loading, run} = useRequest(params.onRequest || (() => Promise.resolve()), {
        manual: true,
        onSuccess: ((data, _) => {
            params.onOk(data)
        })
    })


    function onModalCancel() {
        setVisible(false)
    }

    function onModalOk(_: any, extra?: { [key: string]: any }) {
        form.validateFields().then(values => {
            let val = {...records, ...values, ...(extra || {})}
            if (params.beforeRequest) {
                val = params.beforeRequest(val)
            }
            if (params.onRequest) {
                run(val)
            } else {
                params.onOk(val)
            }
        })
    }

    function setModalVisible(visible: boolean, rc?: T) {
        if (params.normalize && rc) {
            rc = params.normalize(rc)
        }
        if (visible) {
            form.resetFields()
            rc && form.setFieldsValue(rc)
        }
        setRecords(rc)
        setVisible(visible)
    }

    return {
        visible: visible,
        setVisible: setModalVisible,
        modalProps: {
            form: form,
            open: visible,
            onCancel: onModalCancel,
            onOk: onModalOk,
            confirmLoading: loading,
        }
    }
}

export default useFormModal
